/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Team_Manager_Owner_Must_Be_AdminInputs */

const en_team_manager_owner_must_be_admin = /** @type {(inputs: Team_Manager_Owner_Must_Be_AdminInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`User (${i?.email}) is the team owner and can not be added as a non-admin user.`)
};

const fr_team_manager_owner_must_be_admin = /** @type {(inputs: Team_Manager_Owner_Must_Be_AdminInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L’utilisateur (${i?.email}) est le propriétaire de l’équipe et ne peut pas être ajouté comme utilisateur non administrateur.`)
};

const de_team_manager_owner_must_be_admin = /** @type {(inputs: Team_Manager_Owner_Must_Be_AdminInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Benutzer (${i?.email}) ist der Teambesitzer und kann nicht als Nicht-Administrator-Benutzer hinzugefügt werden.`)
};

const it_team_manager_owner_must_be_admin = /** @type {(inputs: Team_Manager_Owner_Must_Be_AdminInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'utente (${i?.email}) è il proprietario del team e non può essere aggiunto come utente non amministratore.`)
};

const ru_team_manager_owner_must_be_admin = /** @type {(inputs: Team_Manager_Owner_Must_Be_AdminInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пользователь (${i?.email}) является владельцем команды и не может быть добавлен в качестве пользователя без прав администратора.`)
};

const es_team_manager_owner_must_be_admin = /** @type {(inputs: Team_Manager_Owner_Must_Be_AdminInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El usuario (${i?.email}) es el propietario del equipo y no se puede agregar como usuario no administrador.`)
};

const zh_cn2_team_manager_owner_must_be_admin = /** @type {(inputs: Team_Manager_Owner_Must_Be_AdminInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用户（${i?.email}）是团队所有者，不能作为非管理员用户添加。`)
};

const ja_team_manager_owner_must_be_admin = /** @type {(inputs: Team_Manager_Owner_Must_Be_AdminInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ユーザー (${i?.email}) はチーム所有者であり、管理者以外のユーザーとして追加することはできません。`)
};

const hi_team_manager_owner_must_be_admin = /** @type {(inputs: Team_Manager_Owner_Must_Be_AdminInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता (${i?.email}) टीम का स्वामी है और उसे गैर-प्रशासक उपयोगकर्ता के रूप में नहीं जोड़ा जा सकता है।`)
};

const pt_pt2_team_manager_owner_must_be_admin = /** @type {(inputs: Team_Manager_Owner_Must_Be_AdminInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O usuário (${i?.email}) é o proprietário da equipe e não pode ser adicionado como um usuário não administrador.`)
};

/**
* | output |
* | --- |
* | "User ({email}) is the team owner and can not be added as a non-admin user." |
*
* @param {Team_Manager_Owner_Must_Be_AdminInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_owner_must_be_admin = /** @type {((inputs: Team_Manager_Owner_Must_Be_AdminInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Owner_Must_Be_AdminInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_owner_must_be_admin(inputs)
	if (locale === "de") return de_team_manager_owner_must_be_admin(inputs)
	if (locale === "it") return it_team_manager_owner_must_be_admin(inputs)
	if (locale === "ru") return ru_team_manager_owner_must_be_admin(inputs)
	if (locale === "es") return es_team_manager_owner_must_be_admin(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_owner_must_be_admin(inputs)
	if (locale === "ja") return ja_team_manager_owner_must_be_admin(inputs)
	if (locale === "hi") return hi_team_manager_owner_must_be_admin(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_owner_must_be_admin(inputs)
	return en_team_manager_owner_must_be_admin(inputs)
});